import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'app',
      redirect: '/exam-query',
      component: App
    },
    {
      path: '/exam-query',
      name: 'exam-query',
      meta: {
        title: '考试'
      },
      redirect: 'exam-query/search',
      component: () => import('./views/examQuery/Index'),
      children: [
        {
          path: 'search/:id',
          name: 'search',
          meta: {
            title: '考试查询'
          },
          component: () => import('./views/examQuery/Search')
        }
      ]
    }
  ]
})
export default router;
